import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle'
import { faPaw } from '@fortawesome/free-solid-svg-icons/faPaw'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { useSnapshot } from 'valtio'
import { drawerState, showPetList as togglePetList } from '../../store/drawerState.ts'
// import { safeZoneState, setSafeZonePolygons, setNewSafeZone, resetSafeZone } from '../../store/safeZoneState.ts'
// import { DesktopPetList } from './DesktopPetList.tsx'

export const DesktopPetDrawerButton = () => {
    const [open, setOpen] = React.useState(false)
    const drawerOpen = useSnapshot(drawerState).drawerOpen
    // const safeZoneActive = (useSnapshot(safeZoneState) as typeof safeZoneState).active
    const petListVisible = useSnapshot(drawerState).petList
    
    React.useEffect(() => {
        if (!drawerOpen && open) {
            setOpen(false)
        }
    }, [drawerOpen])
    
    const icon = (
        <div
            className={'flex justify-center items-center h-fit w-fit rounded-full bg-white border-primary border-solid border-4'}>
            <span className="fa-layers fa-fw fa-lg h-[36px] w-[36px]">
                <FontAwesomeIcon style={{color: petListVisible ? 'white' : 'hsl(var(--p))'}} icon={faCircle} fontSize={'36px'}/>
                <FontAwesomeIcon inverse icon={faPaw} fontSize={'36px'} transform="shrink-3" mask={faCircle}
                                 style={{color: petListVisible ? 'hsl(var(--p))' : 'white'}}/>
            </span>
        </div>
    )
    const button = (
        <div
            onClick={() => {
                // if (safeZoneActive) {
                //     safeZoneState.active = false
                //     setDrawerOpen(false)
                //     setTimeout(() => {
                //         setOpen(true)
                //         setDrawerChildren(<DesktopPetList/>)
                //         setDrawerOpen(true)
                //     }, 500)
                // } else {
                //     setOpen(!open)
                //     setDrawerOpen(!open)
                // }
                togglePetList(!petListVisible)
            }}
        >
            {icon}
        </div>
    )
    return (
        <div className={'relative'}>
            {button}
        </div>
    )
}
